/*  camelcase */
export default {
    name: ['required', 'trim', 'string'],
};